<template>
  <div class="flex flex-row gap-3 items-center my-2">
    <TMSecondaryButton
      v-for="option in feedbackReasonOptions"
      :key="option"
      :label="option"
      :disabled="!!granularFeedback"
      :icon="buttonIcon(option)"
      @click="() => submitGranularFeedback(option)"
    />
  </div>
</template>

<script lang="ts">
import TMSecondaryButton from '@nashville/button/TMSecondaryButton.vue'
import { defineComponent } from 'vue'
import { setup } from './controller'
import { GRANULAR_FEEDBACK_PROPS } from './types'

export default defineComponent({
  components: { TMSecondaryButton },
  props: GRANULAR_FEEDBACK_PROPS,
  setup,
})
</script>
